<template>


<h3>Choose multiple</h3>
<div v-for="(name,index) in courses" :key="index">
    <input type="checkbox" v-model="filter.course" >{{name}}

</div>


<form>
</form>
</template>

<script>
export default {
data(){
return{

    courses:[],

    filter: {
        
        course:''

   }
}
},

watch:{
filter:{
    handler(){
    this.$router.push({
        query:this.filter
    })
    },
    deep:true
}
}

}
</script>